import React from 'react';
import { Box, List, ListItem, ListItemIcon, Avatar, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/NotificationsOutlined';
import ChatIcon from '@mui/icons-material/ChatOutlined';
import VideocamIcon from '@mui/icons-material/VideocamOutlined';
import PersonIcon from '@mui/icons-material/PersonOutlined';
import GroupsIcon from '@mui/icons-material/GroupsOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonthOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import AppsIcon from '@mui/icons-material/Apps';

const NavSidebar = ({ activeTab, onTabChange, isMobile }) => {
    const userJson = localStorage.getItem('x2infotech_user');
    let user = null;
    try { user = userJson ? JSON.parse(userJson) : null; } catch (e) { }

    const navItems = [
        { id: 'activity', icon: <NotificationsIcon />, label: 'Activity' },
        { id: 'chat', icon: <ChatIcon />, label: 'Chat' },
        { id: 'meet', icon: <VideocamIcon />, label: 'Meet' },
        { id: 'people', icon: <PersonIcon />, label: 'People' },
        { id: 'teams', icon: <GroupsIcon />, label: 'Teams' },
        { id: 'calendar', icon: <CalendarMonthIcon />, label: 'Calendar' },
    ];

    return (
        <Box
            sx={{
                width: isMobile ? '100%' : 68,
                height: isMobile ? 'auto' : '100%',
                background: '#f5f5f5', 
                display: 'flex',
                flexDirection: isMobile ? 'row' : 'column',
                alignItems: 'center',
                py: isMobile ? 0.5 : 2,
                px: isMobile ? 1 : 0,
                borderRight: isMobile ? 'none' : '1px solid #edebe9',
                borderTop: isMobile ? '1px solid #edebe9' : 'none',
                justifyContent: isMobile ? 'space-around' : 'flex-start'
            }}
        >
            {!isMobile && (
                <Avatar
                    sx={{
                        width: 34,
                        height: 34,
                        bgcolor: '#4b53bc',
                        color: '#ffffff',
                        fontSize: 14,
                        fontWeight: 600,
                        cursor: 'pointer',
                        mb: 2
                    }}
                >
                    {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
                </Avatar>
            )}

            <List sx={{ 
                width: '100%', 
                p: 0, 
                display: 'flex', 
                flexDirection: isMobile ? 'row' : 'column',
                justifyContent: isMobile ? 'space-around' : 'flex-start'
            }}>
                {navItems.map((item) => {
                    const isSelected = activeTab === item.id;
                    return (
                        <Tooltip key={item.id} title={item.label} placement={isMobile ? "top" : "right"}>
                            <ListItem
                                button
                                onClick={() => onTabChange(item.id)}
                                sx={{
                                    flexDirection: 'column',
                                    py: isMobile ? 1 : 1.4,
                                    px: 0,
                                    color: isSelected ? '#4b53bc' : '#616161',
                                    borderLeft: !isMobile && isSelected ? '3px solid #4b53bc' : '3px solid transparent',
                                    borderBottom: isMobile && isSelected ? '3px solid #4b53bc' : '3px solid transparent',
                                    bgcolor: isSelected ? 'rgba(75, 83, 188, 0.08)' : 'transparent',
                                    '&:hover': {
                                        background: '#edebe9',
                                        color: '#4b53bc',
                                    },
                                    minWidth: isMobile ? 'auto' : '100%',
                                    flex: isMobile ? 1 : 'none'
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        color: 'inherit',
                                        mb: isMobile ? 0 : 0.5
                                    }}
                                >
                                    {item.icon}
                                </ListItemIcon>
                                {!isMobile && (
                                    <Box sx={{ fontSize: '10px', fontWeight: isSelected ? 600 : 400 }}>
                                        {item.label}
                                    </Box>
                                )}
                            </ListItem>
                        </Tooltip>
                    );
                })}
            </List>
            
            {isMobile && (
                <Avatar
                    sx={{
                        width: 28,
                        height: 28,
                        bgcolor: '#4b53bc',
                        color: '#fff',
                        fontSize: 12,
                        fontWeight: 600,
                        cursor: 'pointer',
                        ml: 1
                    }}
                >
                    {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
                </Avatar>
            )}
        </Box>
    );
};

export default NavSidebar;
